import { createContext, ReactNode, useContext } from 'react'

import { TogetherAuthConfigContextProvider } from '@hhgtech/hhg-components/together'
import { redirectToSSOWithReturnUrl } from 'api/utils'
// import { useRouter } from 'next/router'
import { actionTypes } from 'state/actionTypes'
import { AppContext } from 'state/appContext'

// import { ReducerAction } from '../'
// import { joinLeaveCommunity } from '../hooks/useCommunityAction'
// import { joinLeaveTopic } from '../hooks/useTopicAction'
// import { BASE_PATH } from '../interfaces/constants'

// export const joinStoredCommunityTopic = async (
//   locale: string,
//   dispatch?: (action: ReducerAction) => void,
//   onReload?: () => void,
// ) => {
//   const communityIds =
//     JSON.parse(localStorage.getItem('to_join_community_ids') || '[]') || []
//   const topicIds =
//     JSON.parse(localStorage.getItem('to_join_topic_ids') || '[]') || []
//   const [res1, res2] = await Promise.all([
//     communityIds?.length
//       ? joinLeaveCommunity({
//           ids: communityIds,
//           isJoin: true,
//           locale,
//           dispatch,
//         })
//       : Promise.resolve(),
//     topicIds?.length
//       ? joinLeaveTopic({
//           ids: topicIds,
//           isJoin: true,
//           locale,
//           dispatch,
//         })
//       : Promise.resolve(),
//   ])
//   if (res1?.status === 1) {
//     localStorage.removeItem('to_join_community_ids')
//     onReload && onReload()
//   }
//   if (res2?.status === 1) {
//     localStorage.removeItem('to_join_topic_ids')
//     onReload && onReload()
//   }
// }

export type Context = {
  defaultParams?: {
    [k: string]: string
  }
  basePath?: string
}

export const AuthConfigContext = createContext({} as Context)

export const AuthConfigContextProvider = ({
  children,
  basePath = '',
  defaultParams,
}: {
  children: ReactNode
  basePath: string
  defaultParams?: {
    [k: string]: any
  }
}) => {
  return (
    <AuthConfigContext.Provider
      value={{
        basePath,
        defaultParams,
      }}
    >
      <TogetherAuthConfigContextProvider defaultParams={defaultParams}>
        {children}
      </TogetherAuthConfigContextProvider>
    </AuthConfigContext.Provider>
  )
}

export const useAuthRequiredAction = (propsParams?: { [k: string]: any }) => {
  const { state, dispatch } = useContext(AppContext)
  const { basePath, defaultParams } = useContext(AuthConfigContext) || {}
  // const { locale = 'vi-VN' } = useRouter()
  const { userInfo } = state
  const isLoggedIn = userInfo?.id
  const isFirstInteract =
    userInfo &&
    typeof userInfo.communities_interacted === 'number' &&
    userInfo.communities_interacted === 0
  const authActionWrapper = (
    func?: () => any,
    extraParams?: {
      [k: string]: any
    },
  ) => {
    const params = {
      ...defaultParams,
      ...propsParams,
      ...extraParams,
    }
    if (!isLoggedIn || isFirstInteract) {
      if (params?._joinCommunityIds) {
        localStorage.setItem(
          'to_join_community_ids',
          JSON.stringify(
            Array.from(
              new Set(
                (
                  JSON.parse(
                    localStorage.getItem('to_join_community_ids') || '[]',
                  ) || []
                )
                  .concat(params._joinCommunityIds)
                  .filter(Boolean),
              ),
            ),
          ),
        )
        delete params?._joinCommunityIds
      }
      if (params?._joinTopicIds) {
        localStorage.setItem(
          'to_join_topic_ids',
          JSON.stringify(
            Array.from(
              new Set(
                (
                  JSON.parse(
                    localStorage.getItem('to_join_topic_ids') || '[]',
                  ) || []
                )
                  .concat(params._joinTopicIds)
                  .filter(Boolean),
              ),
            ),
          ),
        )
        delete params?._joinTopicIds
      }
      if (!isLoggedIn) {
        dispatch({
          type: actionTypes.LOGOUT,
        })
        // replace(asPath)
      }
      const currentLocation = params?._location || window.location.href
      delete params?._location
      redirectToSSOWithReturnUrl(
        `${
          window.location.origin
        }${basePath}/on-boarding?return=${encodeURIComponent(
          currentLocation,
        )}&source=communities`,
        params as any,
      )
      return null
    } else {
      return func && func()
    }
  }
  return {
    authActionWrapper,
    params: {
      ...defaultParams,
      ...propsParams,
    },
  }
}
